(function ($) {
    var cheilLikes = $.extend({
            ajaxUrl: '',
            nonce: '',
            postId: ''
        }, window.hasOwnProperty('cheilLikes') ? window.cheilLikes : {}
    );

    $('#quick-layer-like').on('click', function (e) {
        var $this = $(this),
            action = '';

        if ($this.hasClass('cheil-post-liked')) {
            action = 'cheil_unset_like';
        } else {
            action = 'cheil_set_like';
        }

        $.ajax(cheilLikes.ajaxUrl, {
            method: 'post',
            data: {
                action: action,
                nonce: cheilLikes.nonce,
                post_id: cheilLikes.postId
            },
            success: function (response) {
                if (response.success) {
                    if ('cheil_set_like' === action) {
                        $this.addClass('cheil-post-liked active');
                    } else if ('cheil_unset_like' === action) {
                        $this.removeClass('cheil-post-liked active');
                    }
                } else if (
                    Array.isArray(response.data) && response.data.length &&
                    response.data[0].hasOwnProperty('code') && response.data[0].hasOwnProperty('message')
                ) {
                    alert(response.data[0].code + ': ' + response.data[0].message);
                } else {
                    console.error(response.data.toString());
                }
            },
            error: function (jqXhr, textStatus, errorThrown) {
                alert(jqXhr.status + ': ' + errorThrown);
            }
        });

        e.preventDefault();
    });
})(jQuery);
